import React, { useEffect, useRef, useState } from "react";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import FormatDate, { formatTimeAgo } from "go-core/components/Formatters/FormatDate";
import { IntercomConversationSourceApi } from "../../../../../../../../services/Api/Admin/adminTypes";

interface Props {
	content: IntercomConversationSourceApi;
	updatedAt: string;
}

const ConversationContent = ({ content, updatedAt }: Props) => {
	const ref = useRef<HTMLDivElement | null>(null);
	const [displayMore, setDisplayMore] = useState(false);
	const { t } = useTranslation("admin");
	useEffect(() => {
		const offsetHeight = ref.current?.offsetHeight;
		const scrollHeight = ref.current?.scrollHeight;
		if (offsetHeight && scrollHeight && offsetHeight < scrollHeight) {
			setDisplayMore(true);
		}
	}, [ref]);

	const showMore = () => {
		const el = document.getElementById(`show-more-${content.id}`);
		const messageElement = document.getElementById(`message-${content.id}`);
		if (el) {
			el.innerText.includes(t("common.action.show_more", { ns: "lib" }))
				? messageElement?.classList.remove("intercom-conversation-message")
				: messageElement?.classList.add("intercom-conversation-message");
			el.innerText = el.innerText.includes(t("common.action.show_more", { ns: "lib" }))
				? `${t("lib:common.action.show_less")}`
				: `${t("common.action.show_more", { ns: "lib" })}`;
		}
	};

	const isMessageImage = content?.message?.includes("<img");

	return (
		<div className="d-flex mb-2">
			<div className={`flex-column ${isMessageImage ? "w-70" : ""}`}>
				{isMessageImage ? (
					<div className="intercom-conversation-message-image">
						<div
							id={`message-${content.id}`}
							className="intercom-conversation-message"
							ref={ref}
							dangerouslySetInnerHTML={{ __html: content.message }}
						/>
					</div>
				) : (
					<div
						id={`message-${content.id}`}
						className="intercom-conversation-message"
						ref={ref}
						dangerouslySetInnerHTML={{ __html: content.message }}
					/>
				)}
				{displayMore && (
					<div id={`show-more-${content.id}`} className="intercom-info" onClick={() => showMore()}>
						{t("common.action.show_more", { ns: "lib" })}
					</div>
				)}
			</div>
			<div className="ms-auto">
				<div className="intercom-info intercom-time-ago">
					<OverlayTrigger
						placement="top"
						overlay={<Tooltip id={`tooltip-${content.id}`}>{FormatDate(updatedAt)}</Tooltip>}
					>
						{({ ref, ...triggerHandler }) => (
							<span ref={ref} {...triggerHandler}>
								{formatTimeAgo(updatedAt, t)}
							</span>
						)}
					</OverlayTrigger>
				</div>
			</div>
		</div>
	);
};

export default ConversationContent;
